import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledRefinePanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 380px;
    width: 320px;
    box-sizing: border-box;
    padding: 12px 12px 0;
    border: 1px solid ${colorsPalettes.carbon["50"]};
    border-radius: 6px;
    box-shadow: 0px 3px 6px 0px #0e1e3e14;
    background:
        linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
        linear-gradient(
            188.68deg,
            rgba(168, 247, 207, 0.2) -8.84%,
            rgba(166, 192, 255, 0.2) 21.09%,
            rgba(255, 255, 255, 0.2) 92.43%
        );
`;

export const StyledRefinePanelInnerContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 0 16px 12px;
    overflow: hidden;
    border-radius: 6px;
    background:
        linear-gradient(#fff, #fff) padding-box,
        linear-gradient(180deg, #e6e9ec 0%, #ffffff 100%) border-box;
`;
